import React, { Component } from 'react'

import { withTranslation } from 'react-i18next'

import Autocomplete from 'components/autocomplete'
import { isEmpty } from 'helpers/utils'
import NAMESPACES from 'localization/constants/namespaces'

const getSuggestionValue = suggestion => {
  return suggestion.id
}

const renderSuggestion = suggestion => {
  return suggestion.display || ''
}

const renderSectionTitle = section => {
  return section.title
}

const getSectionSuggestions = section => {
  return section.history
}

class AutocompleteWithHistory extends Component {
  constructor(props) {
    super(props)

    this.state = {
      isMultisection: true,
      recent: [
        {
          title: this.props.t('shopping.search-box.recent-searchs'),
          history: []
        }
      ]
    }

    this.onSuggestionsFetchRequested = this.onSuggestionsFetchRequested.bind(this)
    this.onSuggestionSelected = this.onSuggestionSelected.bind(this)
  }

  componentDidMount() {
    this.updateRecentSearchs()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.exclusionValue !== this.props.exclusionValue) {
      this.updateRecentSearchs()
    }
  }

  updateRecentSearchs = () => {
    this.setState({
      recent: [
        {
          title: this.props.t('shopping.search-box.recent-searchs'),
          history: this.getRecentSearchs()
        }
      ]
    })
  }

  getRecentSearchs = () => {
    const data = JSON.parse(localStorage.getItem(this.props.storageKey))
    const { exclusionValue } = this.props

    if (data && data.history) {
      return isEmpty(exclusionValue)
        ? data.history
        : data.history.filter(suggestion => suggestion.id !== exclusionValue.id)
    }
    return []
  }

  onSuggestionsFetchRequested = suggestionEvent => {
    if (
      suggestionEvent.reason === 'input-focused' ||
      suggestionEvent.value.length < this.props.minLength
    ) {
      this.setState({
        isMultisection: true
      })
    } else {
      this.props.handleInputChange(suggestionEvent)
      this.setState({
        isMultisection: false
      })
    }
  }

  onSuggestionSelected = suggestion => {
    this.props.handleSuggestionSelected(suggestion)
    this.state.isMultisection && this.props.fetchSuggestions(suggestion)
  }

  getSuggestions = () => {
    const { fetchedSuggestions, index, exclusionValue } = this.props

    if (this.state.isMultisection) {
      return this.state.recent
    }

    if (!fetchedSuggestions || !fetchedSuggestions[index]) {
      return []
    }

    const result = exclusionValue
      ? fetchedSuggestions[index].filter(
          suggestion => suggestion && suggestion.id !== exclusionValue.id
        )
      : fetchedSuggestions[index]

    return result
  }

  render() {
    return (
      <Autocomplete
        placeholder={this.props.placeholder}
        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
        onSuggestionSelected={this.onSuggestionSelected}
        value={this.props.value}
        shouldRenderSuggestions
        error={this.props.error}
        name={this.props.name}
        id={this.props.id}
        index={this.props.index}
        e2eClass={this.props.e2eClass}
        flatStyle={this.props.flatStyle}
        rightButton={this.props.rightButton}
        onChange={this.props.onChange}
        suggestions={this.getSuggestions()}
        getSuggestionValue={getSuggestionValue}
        renderSuggestion={renderSuggestion}
        renderSectionTitle={renderSectionTitle}
        getSectionSuggestions={getSectionSuggestions}
        multiSection={this.state.isMultisection}
        isExpanded={this.props.isExpanded}
        isResearch={this.props.isResearch}
      />
    )
  }
}

export default withTranslation(NAMESPACES.SEARCH_BOX)(AutocompleteWithHistory)
